module.exports = __webpack_public_path__ + "img/inktober_2020_20_coral.fc4b495a.jpg";